import React from 'react'

const MembershipDetails = () => {
  return (
    <div>MembershipDetails</div>
  )
}

export default MembershipDetails